import { IoLogOutOutline } from 'react-icons/io5';

import { useRoot } from '../../../context/RootProvider';
import { Avatar, Popover, Typography } from '../../../designComponents';
import { LOG_OUT_ROUTE } from '../../../routes/routePaths';
import {
  ActiveProfileContainerStyled,
  LinkStyled,
  ProfilePopoverContentContainerStyled,
} from './profile.style';

const ActiveProfile = () => {
  const { auth } = useRoot();

  return (
    <ActiveProfileContainerStyled>
      <div className="profile-info">
        <Typography className="user-name" ellipsis>
          {auth?.fullName || 'User Name'}
        </Typography>
        <Typography variant="caption" fontColor="border">
          {auth?.contactInfo?.country || 'Country'}
        </Typography>
      </div>
      <Popover
        trigger={
          <Avatar
            src={auth?.avatar + `?img=15`}
            size={'md'}
            alt="profile"
            className="profile-avatar"
          />
        }
        placement="right"
        noPadding
      >
        <ProfilePopoverContentContainerStyled>
          <LinkStyled to={LOG_OUT_ROUTE}>
            <IoLogOutOutline />
            <Typography>Logout</Typography>
          </LinkStyled>
        </ProfilePopoverContentContainerStyled>
      </Popover>
    </ActiveProfileContainerStyled>
  );
};

export default ActiveProfile;
